<template>
  <swiper
    v-if="images?.length >= 1"
    class="slide"
    :modules="modules"
    :slides-per-view="1"
    :space-between="50"
    :pagination="{ clickable: true }"
    :loop="true"
  >
    <swiper-slide v-for="(image, index) in images" :key="index" class="slide__image">
      <img :src="`${$store.state.SERVER}/storage/${image}`" :alt="`Картинка ${index + 1}`" />
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      modules: [Pagination],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";
.slide {
  position: relative;
  padding-bottom: 30px;
  width: 100%;
  &__image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 163px;
    border-radius: 20px;
    overflow: hidden;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
  :deep(.swiper-pagination-bullet) {
    background-color: $color-positive !important;
  }
}
</style>
